window.console.log('proves', process.env)

const environment = {
    development: {
        baseUrl: 'https://aspexperience-api-dev.tfs.toyota.com/',
        auctionExperienceApi: 'asp-experience-api/v1/',
        remktExperienceApi: 'remarketing-domain-services/remkt-experience-api/v1/',
        clientId: '0oa17x44wb5iqzdvy0h8',
        issuerUrl: 'https://tfs.oktapreview.com/oauth2/ausredslpqIsIjQfz0h7',
        redirectUrl: 'https://asp-dev.mfindealerservices.com/login3',
        clientS: '58121AA2C86EC4F3FC7D6264966B70F4D34FBB0DA2DB7F8FA7A707629476A72E',
        accessTokenClientS: process.env.REACT_APP_ACCESSTOKEN_CLIENT_SECRET
    },
    test: {
        baseUrl: 'https://apigateway-test.toyotafinancial.com/',
        auctionExperienceApi: 'auction-platform-services/asp-experience-api/v1/',
        remktExperienceApi: 'remarketing-domain-services/remkt-experience-api/v1/',
        clientId: '0oa10kbu8utGtVjgY0h8',
        issuerUrl: 'https://tfs.oktapreview.com/oauth2/ausredslpqIsIjQfz0h7',
        redirectUrl: 'https://asp-test.mfindealerservices.com/login3',
        clientS: '58121AA2C86EC4F3FC7D6264966B70F4D34FBB0DA2DB7F8FA7A707629476A72E',
        accessTokenClientS: process.env.REACT_APP_ACCESSTOKEN_CLIENT_SECRET
    },
    stage: {
        baseUrl: 'https://apigateway-stage.toyotafinancial.com/',
        auctionExperienceApi: 'auction-platform-services/asp-experience-api/v1/',
        remktExperienceApi: 'remarketing-domain-services/remkt-experience-api/v1/',
        clientId: '0oa10kchmc4Hjj6gD0h8',
        issuerUrl: 'https://tfs.oktapreview.com/oauth2/ausredslpqIsIjQfz0h7',
        redirectUrl: 'https://asp-stage.mfindealerservices.com/login3',
        clientS: '58121AA2C86EC4F3FC7D6264966B70F4D34FBB0DA2DB7F8FA7A707629476A72E',
        accessTokenClientS: process.env.REACT_APP_ACCESSTOKEN_CLIENT_SECRET
    },
    prod: {
        baseUrl: 'https://apigateway.toyotafinancial.com/',
        auctionExperienceApi: 'auction-platform-services/asp-experience-api/v1/',
        remktExperienceApi: 'remarketing-domain-services/remkt-experience-api/v1/',
        clientId: '0oa5yn5auhmEDtFbP4x7',
        issuerUrl: 'https://tfs.okta.com/oauth2/ausflfdkt7D88I6xT4x6',
        redirectUrl: 'https://asp.mfindealerservices.com/login3',
        clientS: '58121AA2C86EC4F3FC7D6264966B70F4D34FBB0DA2DB7F8FA7A707629476A72E',
        accessTokenClientS: process.env.REACT_APP_ACCESSTOKEN_CLIENT_SECRET
    }
};

export default environment;
